import Accessor from '@arcgis/core/core/Accessor';
import { property, subclass } from '@arcgis/core/core/accessorSupport/decorators';
import { whenDefinedOnce } from '@arcgis/core/core/watchUtils';
import WebMap from '@arcgis/core/WebMap';

@subclass('Landing.data.ItemLoader.ItemLoaderViewModel')
export default class ItemLoaderViewModel extends Accessor {

    @property()
    portal: __esri.Portal;

    @property()
    isItemLoaderDone: boolean = false;

    @property()
    webmap: WebMap;

    @property()
    loadedItemType: "webmap" | "scene" | "group" | "none";

	constructor(params?: any) {
        super(params);

        whenDefinedOnce(this, "portal", ()=>{
            const urlParams = new URLSearchParams(window.location.search);
            const webmapId: string = urlParams.get('webmap');
            if(webmapId){
                this.webmap = new WebMap({
                    portalItem: {
                        id: webmapId,
                        portal: this.portal
                    }
                });
                this.loadedItemType = "webmap";
            }
            // TODO: else if(websceneId)
            // this.loadedItemType = "scene";
            // TODO: else if(groupId)
            // this.loadedItemType = "group";
            else{
                this.loadedItemType = "none";
            }
            this.isItemLoaderDone = true;
        });
    }

}
